<template>
  <div class="Influencers">
    <div class="top">
        <pre class="font_bo">
                                Influencers Privacy Policy
        </pre>
        <pre class="font_bo">
             


        Latest Updated at May 31, 2022
        </pre>
        <pre>


        This Influencers Privacy Policy (“IPP”) describes how we collect, use, store 

        and disclose personal information that is relevant to you as an influencer and it 
        
        also specifies clear rules about what kind of rights you as an influencer have 

        and how you can exercise those rights. The IPP contains information that is 

        important for you, therefore please be assured to read that information to fully 

        understand the practices in relation to your personal information as influencers.

        </pre>
        <pre class="font_bo">
        WHO WE ARE AND WHY WE COLLECT ABOUT YOU AS AN INFLUENCER?
        </pre>
        <pre>
        We are a company called Shenzhen Zizaibide Technology Co., LTD 

        incorporated under the laws of Shenzhen with our principal business address 

        located at Room201, Building A, No.1 Qianwanyi Road, Qianhai, Shenzhen, 

        China. We own and operate an online marketing platform where we facilitate 

        our customers to discover, manage, engage with, and build meaningful 

        relationship with influencers worldwide. 


        In order to achieve this objective, we need to collect personal information 

        publicly available about you through techniques we develop via all kinds of 

        open sources and then further build a comprehensive profile about you on our 

        platform so that our customers will be able to view your profile and identify 

        whether they will be interested in engaging you for advertising purpose.
        </pre>


        <pre class="font_bo">

            
        THE INFORMATION WE COLLECT ABOUT YOU AND HOW WE COLLECT IT?
        </pre>
        <pre>
        

        We collect, use, store and transfer different kinds of publicly available personal 

        information about you which is obtained directly or indirectly via various data 
        
        sources such as social media networks and other internet sources. This personal 

        information may include the following: your contact details, name, user name, 

        age and affiliated organization (if applicable); your social media profile and 

        activity; messages which you have shared publicly on social media,websites; 

        and any other information you manifestly make public.


        We gather the above-mentioned personal information through legal and 

        proprietary techniques independently developed by us or authorized to be used 

        by us. You are assured that we will not use any excessive or intrusive 

        techniques prohibited by any applicable laws to collect personal information 

        about you. 
        </pre>
        <pre class="font_bo">


        LEGAL BASIS FOR PROCESSING
        </pre>
        <pre>
        When we collect and use/process your personal information to achieve our 

        business objectives as stated above, we are the Data Controller as defined 

        under the GDPR or any other applicable data protection laws. The legal basis 

        for our processing of the collected personal information about you is the 

        legitimate interest that we are pursuing which is not overridden by your 

        fundamental rights. The legitimate interests we are pursing are not only 

        interests for us but also interest for you because by processing your personal 

        information and use it on our platform you will have more opportunity to reach 

        out to potential advertisers and that will help you increase your customer base 

        and of course will in turn increase your revenue and profits.


        At the same time, all the personal information processed by us are exclusively 

        collected from public sources where you have already made such information 

        public therefore any subsequent processing activities in relation to your such 

        public information shall have very limited impact on you.


        </pre>
        <pre class="font_bo">
            
        HOW DO WE PROTECT YOUR PERSONAL INFORMATION AND HOW LONG YOUR PERSONA 
        
        INFORMATION WILL BERETAINED?
        </pre>
        <pre>
        


        We have implemented appropriate technical, organizational and security 

        measures designed to protect your personal information. To the extent 

        permitted by applicable laws, your personal information will be retained as    

        long as we need it. Having said so, however, you still have the right under this 

        IPP to request us to erase all personal information retained with us at any time 

        during processing your personal information.     
        </pre>
        <pre class="font_bo">


        DO WE DISCLOSE YOUR PERSONAL INFORMATION WITH THIRD PARTIES?
        </pre>
        <pre>
        
        We do not sell, trade, or otherwise transfer to outside parties your personal

        information. This does not include trusted third parties who assist us in 

        operating our website, conducting our business, executing payments, delivering 

        purchased services, sending you information or updates, or otherwise servicing 

        you, or sharing your contact with our customer.so long as those parties agree to 

        keep this information confidential. We may also release your information when 

        we believe release is appropriate to comply with the law, enforce our site 

        policies, or protect ours or other’s rights, property, or safety.
        </pre>
        <pre class="font_bo">
        

        YOUR RIGHTS AND HOW YOU CAN EXCERISE YOUR RIGHTS?
        </pre>
        <pre>


        We take reasonable steps to ensure that your personal information is accurate, 

        complete, and up to date. You have the right to access, correct, or delete the 

        personal information that we collect. You are also entitled to restrict or object, 

        at any time, to the further processing of your personal information. You have 

        the right to receive your personal information in a structured and standard 

        format and, where technically feasible, the right to have your personal 

        information transmitted directly to a third party. You may lodge a complaint 

        with the competent data protection authority regarding the processing of your 

        personal information.


        To protect the privacy and the security of your personal information, we may 

        request information from you to enable us to confirm your identity and right to 

        access such information, as well as to search for and provide you with the 

        personal information we maintain. There are instances where applicable laws 

        or regulatory requirements allow or require us to refuse to provide or delete 

        some or all the personal information that we maintain.


        You may send us an e-mail to support@foshobrands.com to exercise your 

        rights. We will respond to your request in a reasonable timeframe. We will take 

        all reasonable steps to ensure that your personal data is correct and up to date.
        </pre>
        <pre class="font_bo">
        

        CHANGES TO POLICY
        </pre>
        <pre>
        

        If we decide to change our privacy policy, we will post those changes on this 

        page, and/or update the Privacy Policy modification date below.
        </pre>

        <pre class="font_bo">
        

        CONTACT US
        </pre>
        <pre>
        

        If you would like to exercise one of your rights as set out above, or if you have 

        a question or a complaint about this policy, the way your personal information 

        is processed, please contact us via e-mail: support@foshobrands.com.
        </pre>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {

    }
  }
}
</script>
<style lang="less" scoped>
.Influencers{
  background: #fafafd;
    .centers{
        text-align: center;
    }
    .top{
        width: 1200px;
        margin: 0 auto;
        padding: 100px;
        font-size: 24px;
        box-sizing: border-box;
    }
}
</style>